/* just wonderfully — animations and small interactions for the custom sections.
   Content is fully visible without this file; it only adds motion. */
(function () {
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var io = null, pauseIO = null, raf = 0, dwellTimer = 0;

  function clamp(v) { return v > 1.2 ? 1.2 : v < -1.2 ? -1.2 : v; }

  // phones + upright tablets: the hero blob floats on its own (CSS); keep the generic scroll motion off it
  var heroMQ = null;
  try { heroMQ = window.matchMedia('(max-width: 720px), (max-width: 1024px) and (orientation: portrait)'); } catch (e) {}

  /* ---------- scroll-linked motion ---------- */
  function tick() {
    raf = 0;
    var vh = window.innerHeight || 800;

    // blobs behind the walkthrough phones and hero
    var heroCompact = heroMQ && heroMQ.matches;
    var blobs = document.querySelectorAll('.jw-blob');
    for (var i = 0; i < blobs.length; i++) {
      var el = blobs[i];
      if (heroCompact && el.closest('.jw-hero-stage')) continue;
      var r = el.parentNode.getBoundingClientRect();
      var p = clamp(((r.top + r.height / 2) - vh / 2) / vh);
      var dir = parseFloat(el.getAttribute('data-dir') || '1');
      var flip = el.hasAttribute('data-flip') ? ' scaleX(-1)' : '';
      el.style.transform = 'translate(-50%,-50%) translateY(' + (p * -70).toFixed(1) + 'px) rotate(' + (p * 22 * dir).toFixed(2) + 'deg) scale(' + (1.04 - Math.abs(p) * 0.16).toFixed(3) + ')' + flip;
      el.style.opacity = Math.max(0.35, 0.95 - Math.abs(p) * 0.45).toFixed(2);
    }

    // shop display: blobs drift slower than products (depth)
    var stages = document.querySelectorAll('.jw-shopstage');
    for (var s = 0; s < stages.length; s++) {
      var sr = stages[s].getBoundingClientRect();
      var sp = clamp(((sr.top + sr.height / 2) - vh / 2) / vh);
      var lb = stages[s].querySelector('.jw-layer-b');
      var lp = stages[s].querySelector('.jw-layer-p');
      if (lb) lb.style.transform = 'translateY(' + (sp * 36).toFixed(1) + 'px)';
      if (lp) lp.style.transform = 'translateY(' + (sp * -16).toFixed(1) + 'px)';
    }

    // signup + footer blob clusters
    // story illustration: blobs drift slightly slower than the image
    var arts = document.querySelectorAll('[data-jw-story-art]');
    for (var t = 0; t < arts.length; t++) {
      var ar = arts[t].getBoundingClientRect();
      var ap = clamp(((ar.top + ar.height / 2) - vh / 2) / vh);
      var bl = arts[t].querySelector('.jw-st-blobs');
      var il = arts[t].querySelector('.jw-st-par');
      if (bl) bl.style.transform = 'translateY(' + (ap * -8).toFixed(1) + 'px)';
      if (il && !arts[t].classList.contains('jw-st-has-wave')) il.style.transform = 'translateY(' + (ap * -18).toFixed(1) + 'px)';
    }
    var sb = document.querySelectorAll('.jw-sblob');
    for (var q = 0; q < sb.length; q++) {
      var b = sb[q];
      var br = b.getBoundingClientRect();
      var bp = clamp(((br.top + br.height / 2) - vh / 2) / vh);
      var bd = parseFloat(b.getAttribute('data-dir') || '1');
      b.style.transform = 'translateY(' + (bp * -60).toFixed(1) + 'px) rotate(' + (bp * 18 * bd).toFixed(2) + 'deg) scale(' + (1.05 - Math.abs(bp) * 0.15).toFixed(3) + ')';
    }
  }

  /* phones tilt + lift when the visitor pauses on a chapter */
  function markDwell() {
    var vh = window.innerHeight || 800;
    var st = document.querySelectorAll('.jw-ch-stage');
    for (var i = 0; i < st.length; i++) {
      var r = st[i].getBoundingClientRect();
      var c = r.top + r.height / 2;
      st[i].classList.toggle('jw-dwell', Math.abs(c - vh / 2) < vh * 0.28);
    }
  }

  function onScroll() {
    if (!raf) raf = requestAnimationFrame(tick);
    clearTimeout(dwellTimer);
    var on = document.querySelectorAll('.jw-dwell');
    for (var i = 0; i < on.length; i++) on[i].classList.remove('jw-dwell');
    dwellTimer = setTimeout(markDwell, 650);
  }

  /* ---------- reveal on scroll ---------- */
  function observeReveals(root) {
    if (!io) return;
    var els = (root || document).querySelectorAll('.jw-reveal, .jw-once, .jw-fade, .jw-pop, .jw-soft, .jw-st-rev');
    for (var i = 0; i < els.length; i++) {
      if (els[i].__jwObserved) continue;
      els[i].__jwObserved = true;
      io.observe(els[i]);
    }
    var stg = (root || document).querySelectorAll('.jw-shopstage, [data-jw-story-art]');
    for (var j = 0; j < stg.length; j++) if (pauseIO) pauseIO.observe(stg[j]);
  }

  function startMotion() {
    if (reduce || typeof IntersectionObserver === 'undefined') return;
    document.documentElement.classList.add('jw-anim');
    io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        var en = entries[k], t = en.target;
        var once = t.classList.contains('jw-once') || t.classList.contains('jw-fade') || t.classList.contains('jw-st-rev');
        if (en.isIntersecting) {
          t.classList.add('jw-in');
          if (once) io.unobserve(t);
        } else if (!once && en.boundingClientRect.top > 0) {
          t.classList.remove('jw-in');
        }
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    pauseIO = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) entries[k].target.classList.toggle('jw-paused', !entries[k].isIntersecting);
    }, { threshold: 0 });
    observeReveals(document);
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- header menu ---------- */
  function initMenus(root) {
    var btns = (root || document).querySelectorAll('[data-jw-menu]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        if (btn.__jw) return; btn.__jw = true;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        function set(open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
          panel.hidden = !open;
          if (open) { var first = panel.querySelector('a'); if (first) first.focus(); }
        }
        btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
        panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
        panel.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
      })(btns[i]);
    }
  }

  /* ---------- shop category tabs ---------- */
  function initTabs(root) {
    var groups = (root || document).querySelectorAll('[data-jw-tabs]');
    for (var g = 0; g < groups.length; g++) {
      (function (wrap) {
        if (wrap.__jw) return; wrap.__jw = true;
        var tabs = wrap.querySelectorAll('.jw-tab');
        var intro = wrap.querySelector('[data-jw-intro]');
        function pick(idx) {
          for (var i = 0; i < tabs.length; i++) {
            var on = i === idx;
            tabs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
            var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          }
          if (intro) intro.textContent = tabs[idx].getAttribute('data-intro') || '';
        }
        for (var i = 0; i < tabs.length; i++) (function (n) { tabs[n].addEventListener('click', function () { pick(n); }); })(i);
      })(groups[g]);
    }
  }

  /* ---------- newsletter: validation + loading state ---------- */
  function initNewsletter(root) {
    var forms = (root || document).querySelectorAll('form.jw-nl-form');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.__jw) return; form.__jw = true;
        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button[type="submit"]');
        var msg = form.querySelector('[data-jw-msg]');
        form.addEventListener('submit', function (e) {
          var v = (input.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
            e.preventDefault();
            input.setAttribute('aria-invalid', 'true');
            if (msg) msg.textContent = form.getAttribute('data-invalid') || 'Please check your email address.';
            input.focus();
            return;
          }
          input.removeAttribute('aria-invalid');
          if (msg) msg.textContent = '';
          btn.disabled = true;
          btn.classList.add('jw-loading');
          btn.setAttribute('aria-busy', 'true');
          var label = btn.querySelector('[data-jw-label]');
          if (label) label.textContent = form.getAttribute('data-loading') || 'adding you…';
        });
        // restore the button if the visitor comes back with the browser's back button
        window.addEventListener('pageshow', function () {
          btn.disabled = false; btn.classList.remove('jw-loading'); btn.removeAttribute('aria-busy');
          var label = btn.querySelector('[data-jw-label]');
          if (label && form.getAttribute('data-label')) label.textContent = form.getAttribute('data-label');
        });
      })(forms[i]);
    }
  }

  /* ---------- images fade in once loaded ---------- */
  function initImageFades(root) {
    if (!document.documentElement.classList.contains('jw-anim')) return;
    var imgs = (root || document).querySelectorAll('.jw img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.__jwFade || img.complete) return;
        img.__jwFade = true;
        img.classList.add('jw-img-wait', 'jw-img-ready');
        function done() { img.classList.remove('jw-img-wait'); }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      })(imgs[i]);
    }
  }

  /* ---------- FAQ accordion (one open at a time) ---------- */
  function initFaq(root) {
    var lists = (root || document).querySelectorAll('[data-jw-faq]');
    for (var l = 0; l < lists.length; l++) {
      (function (list) {
        if (list.__jw) return; list.__jw = true;
        list.classList.add('jw-faq-ready');
        var btns = list.querySelectorAll('.jw-faq-q');

        function finish(panel, fn) {
          var doneOnce = false;
          function end(e) {
            if (e && (e.target !== panel || e.propertyName !== 'height')) return;
            if (doneOnce) return; doneOnce = true;
            panel.removeEventListener('transitionend', end);
            fn();
          }
          panel.addEventListener('transitionend', end);
          setTimeout(end, 700);
        }

        function open(btn, panel) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          if (reduce) { panel.classList.add('jw-open'); return; }
          panel.classList.remove('jw-open');
          panel.style.height = '0px';
          void panel.offsetHeight;
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.classList.add('jw-open'); });
          finish(panel, function () { if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = ''; });
        }

        function close(btn, panel) {
          btn.setAttribute('aria-expanded', 'false');
          if (reduce) { panel.classList.remove('jw-open'); panel.hidden = true; return; }
          panel.style.height = panel.scrollHeight + 'px';
          void panel.offsetHeight;
          panel.classList.remove('jw-open');
          panel.style.height = '0px';
          finish(panel, function () {
            if (btn.getAttribute('aria-expanded') === 'false') { panel.hidden = true; panel.style.height = ''; }
          });
        }

        for (var i = 0; i < btns.length; i++) {
          var p = document.getElementById(btns[i].getAttribute('aria-controls'));
          btns[i].setAttribute('aria-expanded', 'false');
          if (p) { p.hidden = true; p.classList.remove('jw-open'); }
          btns[i].addEventListener('click', function (e) {
            var btn = e.currentTarget;
            var panel = document.getElementById(btn.getAttribute('aria-controls'));
            if (!panel) return;
            var isOpen = btn.getAttribute('aria-expanded') === 'true';
            for (var k = 0; k < btns.length; k++) {
              if (btns[k] !== btn && btns[k].getAttribute('aria-expanded') === 'true') {
                close(btns[k], document.getElementById(btns[k].getAttribute('aria-controls')));
              }
            }
            if (isOpen) close(btn, panel); else open(btn, panel);
          });
        }
      })(lists[l]);
    }
  }

  /* ---------- guide popup (Shopify customer signup) ---------- */
  var POP_DISMISS = 'jwGuidePopupDismissedUntil', POP_DONE = 'jwGuidePopupDone', POP_PENDING = 'jwGuidePopupPending';
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function initPopup(root) {
    var wraps = (root || document).querySelectorAll('[data-jw-popup]');
    for (var w = 0; w < wraps.length; w++) {
      (function (wrap) {
        if (wrap.__jw) return; wrap.__jw = true;
        var editor = wrap.getAttribute('data-editor') === 'true';
        var active = wrap.getAttribute('data-active') === 'true';
        var dialog = wrap.querySelector('[role="dialog"]');
        var form = wrap.querySelector('form');
        var formView = wrap.querySelector('[data-jw-pop-view="form"]');
        var okView = wrap.querySelector('[data-jw-pop-view="success"]');
        var copy = wrap.querySelector('[data-jw-pop-copy]');
        var msg = wrap.querySelector('[data-jw-msg]');
        var btn = form ? form.querySelector('button[type="submit"]') : null;
        var lastFocus = null;

        function focusables() {
          return dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])');
        }
        function onKey(e) {
          if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
          if (e.key !== 'Tab') return;
          var f = Array.prototype.filter.call(focusables(), function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
        function open(showSuccess) {
          if (!wrap.hidden) return;
          lastFocus = document.activeElement;
          formView.hidden = !!showSuccess;
          okView.hidden = !showSuccess;
          wrap.hidden = false;
          document.documentElement.classList.add('jw-pop-lock');
          requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('jw-pop-open'); }); });
          document.addEventListener('keydown', onKey);
          setTimeout(function () {
            var target = showSuccess ? okView : wrap.querySelector('input[type="email"]');
            if (target) target.focus();
          }, 80);
        }
        function close(remember) {
          wrap.classList.remove('jw-pop-open');
          document.removeEventListener('keydown', onKey);
          document.documentElement.classList.remove('jw-pop-lock');
          setTimeout(function () { wrap.hidden = true; }, reduce ? 0 : 450);
          if (remember && !editor && read(POP_DONE) !== '1') {
            var days = parseInt(wrap.getAttribute('data-dismiss-days') || '14', 10);
            store(POP_DISMISS, String(Date.now() + days * 864e5));
          }
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        }
        var closers = wrap.querySelectorAll('[data-jw-close]');
        for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', function () { close(true); });

        function showError(text) { if (msg) msg.textContent = text || ''; }
        function setLoading(on) {
          if (!btn) return;
          btn.disabled = on; btn.classList.toggle('jw-loading', on);
          var label = btn.querySelector('[data-jw-label]');
          if (label) {
            if (!label.__orig) label.__orig = label.textContent;
            label.textContent = on ? (copy.getAttribute('data-loading') || 'sending…') : label.__orig;
          }
        }
        function succeed() {
          store(POP_DONE, '1'); store(POP_DISMISS, null);
          try { sessionStorage.removeItem(POP_PENDING); } catch (e) {}
          formView.hidden = true; okView.hidden = false; okView.focus();
        }

        if (form) form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.querySelector('input[type="email"]');
          var v = (email.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
            email.setAttribute('aria-invalid', 'true');
            showError(copy.getAttribute('data-invalid')); email.focus(); return;
          }
          email.removeAttribute('aria-invalid'); showError('');
          var tags = [wrap.getAttribute('data-guide-tag')];
          var opt = form.querySelector('[data-jw-optin]');
          if (opt && opt.checked) tags.push(wrap.getAttribute('data-optin-tag'));
          form.querySelector('[data-jw-tags]').value = tags.filter(Boolean).join(',');
          if (editor && !active) { showError('Signups are switched off in the editor preview.'); return; }
          setLoading(true);
          fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
            .then(function (res) {
              var url = res.url || '';
              if (url.indexOf('customer_posted=true') !== -1) { setLoading(false); succeed(); return; }
              if (url.indexOf('/challenge') !== -1) {
                // Shopify wants a quick human check: finish the signup on its own page.
                try { sessionStorage.setItem(POP_PENDING, '1'); } catch (er) {}
                form.submit(); return;
              }
              setLoading(false); showError(copy.getAttribute('data-error'));
            })
            .catch(function () { setLoading(false); showError(copy.getAttribute('data-error')); });
        });

        // returning from Shopify's human check with a confirmed signup
        var pending = false;
        try { pending = sessionStorage.getItem(POP_PENDING) === '1'; } catch (e) {}
        if (pending && /[?&]customer_posted=true/.test(location.search)) { open(true); succeed(); return; }

        if (editor) {
          document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(wrap)) open(false); });
          document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(wrap)) close(false); });
          return;
        }
        if (!active || read(POP_DONE) === '1') return;
        var until = parseInt(read(POP_DISMISS) || '0', 10);
        if (until && Date.now() < until) return;
        if (wrap.getAttribute('data-mobile') === 'false' && window.matchMedia && window.matchMedia('(max-width: 760px)').matches) return;

        // pages viewed this visit
        var views = 1;
        try { views = parseInt(sessionStorage.getItem('jwGuidePopupViews') || '0', 10) + 1; sessionStorage.setItem('jwGuidePopupViews', String(views)); } catch (e) {}
        if (views < parseInt(wrap.getAttribute('data-pages') || '1', 10)) return;

        var trigger = wrap.getAttribute('data-trigger') || 'time';
        var shown = false;
        function fire() { if (shown) return; shown = true; cleanup(); open(false); }
        var timer = 0;
        function onScrollTrigger() {
          var doc = document.documentElement;
          var max = (doc.scrollHeight - window.innerHeight) || 1;
          var pct = (window.scrollY || doc.scrollTop) / max * 100;
          if (pct >= parseInt(wrap.getAttribute('data-scroll') || '40', 10)) fire();
        }
        function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) fire(); }
        function cleanup() {
          clearTimeout(timer);
          window.removeEventListener('scroll', onScrollTrigger);
          document.removeEventListener('mouseout', onExit);
        }
        if (trigger === 'time' || trigger === 'time_or_scroll') {
          timer = setTimeout(fire, parseInt(wrap.getAttribute('data-delay') || '15', 10) * 1000);
        }
        if (trigger === 'scroll' || trigger === 'time_or_scroll') {
          window.addEventListener('scroll', onScrollTrigger, { passive: true });
        }
        if (trigger === 'exit') {
          var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
          if (touch) timer = setTimeout(fire, parseInt(wrap.getAttribute('data-delay') || '15', 10) * 1000);
          else document.addEventListener('mouseout', onExit);
        }
      })(wraps[w]);
    }
  }

  /* ---------- scrolling bar pause button ---------- */
  function initMarquee(root) {
    var btns = (root || document).querySelectorAll('[data-jw-mq-toggle]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        if (btn.__jw) return; btn.__jw = true;
        var bar = btn.closest('[data-jw-marquee]');
        btn.addEventListener('click', function () {
          var paused = bar.classList.toggle('jw-mq-paused');
          btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        });
      })(btns[i]);
    }
  }

  /* ---------- FAQ category tabs ---------- */
  function initFaqTabs(root) {
    var groups = (root || document).querySelectorAll('[data-jw-faq-tabs]');
    for (var g = 0; g < groups.length; g++) {
      (function (wrap) {
        if (wrap.__jwTabs) return; wrap.__jwTabs = true;
        var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
        var busy = false;
        function panelOf(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }
        // without JavaScript every question shows; with it, only the selected tab's panel does
        tabs.forEach(function (t) { var p = panelOf(t); if (p) p.hidden = t.getAttribute('aria-selected') !== 'true'; });
        function closeAnswers(panel) {
          var open = panel.querySelectorAll('.jw-faq-q[aria-expanded="true"]');
          for (var i = 0; i < open.length; i++) {
            var a = document.getElementById(open[i].getAttribute('aria-controls'));
            open[i].setAttribute('aria-expanded', 'false');
            if (a) { a.hidden = true; a.classList.remove('jw-open'); a.style.height = ''; }
          }
        }
        function select(idx, focus) {
          var next = tabs[idx], cur = null;
          for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('aria-selected') === 'true') cur = tabs[i];
          if (focus) next.focus();
          if (cur === next || busy) return;
          tabs.forEach(function (t) {
            var on = t === next;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.setAttribute('tabindex', on ? '0' : '-1');
          });
          var oldP = cur ? panelOf(cur) : null, newP = panelOf(next);
          function show() {
            if (oldP) { oldP.hidden = true; oldP.classList.remove('jw-fout'); closeAnswers(oldP); }
            newP.hidden = false;
            newP.classList.remove('jw-fin'); void newP.offsetWidth;
            if (!reduce) newP.classList.add('jw-fin');
            var items = newP.querySelectorAll('.jw-faq-item');
            for (var k = 0; k < items.length; k++) items[k].classList.add('jw-in');
            busy = false;
          }
          if (reduce || !oldP) { show(); return; }
          busy = true;
          oldP.classList.add('jw-fout');
          setTimeout(show, 140);
        }
        tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { select(i, false); });
          t.addEventListener('keydown', function (e) {
            var n = tabs.length, j = -1;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
            else if (e.key === 'Home') j = 0;
            else if (e.key === 'End') j = n - 1;
            if (j < 0) return;
            e.preventDefault();
            select(j, true);
          });
        });
      })(groups[g]);
    }
  }

  /* ---------- FAQ waving character: waves while the visitor scrolls ---------- */
  var waves = [];
  function initWave(root) {
    var els = (root || document).querySelectorAll('[data-jw-wave]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__jw) continue; el.__jw = true;
      if (pauseIO) pauseIO.observe(el);
      waves.push({ el: el, arm: el.querySelector('.jw-wave-arm'), amp: 0, target: 0, phase: 0, idle: 0,
        max: parseFloat(el.getAttribute('data-angle') || '7'), period: parseFloat(el.getAttribute('data-period') || '900') });
    }
  }
  var waveRaf = 0, waveLast = 0;
  function waveLoop(ts) {
    var dt = waveLast ? Math.min(64, ts - waveLast) : 16; waveLast = ts;
    var running = false;
    for (var i = 0; i < waves.length; i++) {
      var w = waves[i];
      w.amp += (w.target - w.amp) * Math.min(1, dt / 160);
      w.phase += (dt / w.period) * Math.PI * 2;
      if (w.amp < 0.003 && w.target === 0) { w.amp = 0; if (w.arm) w.arm.style.transform = ''; continue; }
      running = true;
      if (w.arm) w.arm.style.transform = 'rotate(' + (-w.max * w.amp * Math.sin(w.phase)).toFixed(2) + 'deg)';
    }
    if (running) waveRaf = requestAnimationFrame(waveLoop); else { waveRaf = 0; waveLast = 0; }
  }
  function waveOnScroll() {
    if (reduce || !waves.length) return;
    var vh = window.innerHeight || 800;
    for (var i = 0; i < waves.length; i++) {
      var w = waves[i], r = w.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      w.target = 1;
      clearTimeout(w.idle);
      w.idle = setTimeout((function (ww) { return function () { ww.target = 0; }; })(w), 260);
    }
    if (!waveRaf) waveRaf = requestAnimationFrame(waveLoop);
  }
  if (!reduce) window.addEventListener('scroll', waveOnScroll, { passive: true });

  function initCarousels(root) {
    var cars = (root || document).querySelectorAll('[data-jw-carousel]');
    cars.forEach(function (car) {
      if (car.__jw) return; car.__jw = true;
      var track = car.querySelector('[data-jw-car-track]');
      var prev = car.querySelector('[data-jw-car-prev]');
      var next = car.querySelector('[data-jw-car-next]');
      if (!track) return;
      function step() { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 20 : 300; }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // keep the header cart count in step with Dawn's cart updates (quantity changes, removals, add to cart)
  function setCartCount(n) {
    document.querySelectorAll('[data-jw-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-jw-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function refreshCartCount() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }
  // PUB_SUB_EVENTS is a top-level const in Dawn's constants.js, so it isn't on window
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.cartData && typeof e.cartData.item_count === 'number') setCartCount(e.cartData.item_count);
      else refreshCartCount();
    });
  }

  function initAppHands(root) {
    var cards = (root || document).querySelectorAll('[data-jw-at]');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window) || reduce) { cards.forEach(function (c) { c.classList.add('jw-at-in'); }); return; }
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('jw-at-in'); o.unobserve(e.target); } });
    }, { threshold: 0.25 });
    cards.forEach(function (c) { o.observe(c); });
  }

  // our story page: reveal chapters as they enter, gentle parallax on illustrations
  var msPar = [], msRaf = 0;
  function msTick() {
    msRaf = 0;
    var vh = window.innerHeight;
    msPar.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var k = parseFloat(el.getAttribute('data-jw-par')) || 0.06;
      var off = (r.top + r.height / 2 - vh / 2) * -k;
      if (off > 36) off = 36; if (off < -36) off = -36;
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
  }
  function msOnScroll() { if (!msRaf) msRaf = requestAnimationFrame(msTick); }
  function initStoryPage(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('[data-jw-chap], .jw-ms-hero .jw-ms-hero-grid');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      targets.forEach(function (t) { t.classList.add('jw-ms-in'); });
    } else {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('jw-ms-in'); o.unobserve(e.target); } });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (t) { o.observe(t); });
    }
    if (reduce) return;
    scope.querySelectorAll('[data-jw-par]').forEach(function (el) { if (msPar.indexOf(el) < 0) msPar.push(el); });
    if (!initStoryPage.bound) {
      initStoryPage.bound = true;
      window.addEventListener('scroll', msOnScroll, { passive: true });
      window.addEventListener('resize', msOnScroll);
    }
    msOnScroll();
  }

  // Phone browsers tint the strip above the page with the "theme-color".
  // Keep it matched to whatever is currently at the very top of the screen (announcement bar, header, etc.).
  var tcMeta = document.querySelector('meta[name="theme-color"]'), tcRaf = 0, tcLast = '';
  function bgAt(el) {
    while (el && el !== document.documentElement) {
      var c = getComputedStyle(el).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c)) return c.replace(/rgba\(([^,]+),([^,]+),([^,]+),[^)]*\)/, 'rgb($1,$2,$3)');
      el = el.parentElement;
    }
    return '#F5EFE4';
  }
  function tcUpdate() {
    tcRaf = 0;
    if (!tcMeta) return;
    var el = document.elementFromPoint(Math.round(window.innerWidth / 2), 2);
    var c = bgAt(el);
    if (c !== tcLast) { tcLast = c; tcMeta.setAttribute('content', c); }
  }
  function tcSchedule() { if (!tcRaf) tcRaf = requestAnimationFrame(tcUpdate); }
  window.addEventListener('scroll', tcSchedule, { passive: true });
  window.addEventListener('load', tcSchedule);

  // ---- physical vs digital: switch format-specific content when the selected variant changes ----
  function jwVariantFormats() {
    var el = document.querySelector('[data-jw-variant-formats]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function jwApplyFormat(fmt) {
    if (fmt !== 'digital' && fmt !== 'physical') return;
    document.querySelectorAll('product-info[data-jw-fmt]').forEach(function (p) { p.setAttribute('data-jw-fmt', fmt); });
    document.querySelectorAll('[data-jw-show]').forEach(function (el) {
      el.classList.toggle('jw-hide', el.getAttribute('data-jw-show') !== fmt);
    });
  }
  function jwFormatFor(variantId) {
    var map = jwVariantFormats();
    return map && variantId != null ? map[String(variantId)] : null;
  }
  function initFormats() {
    if (initFormats.done || !document.querySelector('[data-jw-variant-formats]')) return;
    initFormats.done = true;
    // Dawn announces variant changes; its payload includes requires_shipping
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (!v) return;
        var fmt = typeof v.requires_shipping === 'boolean' ? (v.requires_shipping ? 'physical' : 'digital') : jwFormatFor(v.id);
        jwApplyFormat(fmt);
      });
    }
    // fallback: the product form's hidden variant id changes
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]') && t.closest('product-info')) {
        var fmt = jwFormatFor(t.value);
        if (fmt) jwApplyFormat(fmt);
      }
    });
  }

  // ---- enlarge gallery images ----
  function initLightbox(root) {
    var btns = (root || document).querySelectorAll('[data-jw-lightbox]');
    if (!btns.length) return;
    var dlg = document.getElementById('jw-pf-lightbox');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'jw-pf-lightbox';
      dlg.className = 'jw-pf-lb';
      dlg.setAttribute('aria-label', 'Enlarged image');
      dlg.innerHTML = '<button type="button" class="jw-pf-lb-close" aria-label="Close">&times;</button><figure><img alt=""><figcaption></figcaption></figure>';
      document.body.appendChild(dlg);
      dlg.querySelector('.jw-pf-lb-close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { if (dlg._opener) dlg._opener.focus(); });
    }
    btns.forEach(function (b) {
      if (b.__jwlb) return; b.__jwlb = true;
      b.addEventListener('click', function () {
        var img = dlg.querySelector('img'), cap = dlg.querySelector('figcaption');
        img.src = b.getAttribute('data-src'); img.alt = b.getAttribute('data-alt') || '';
        var c = b.getAttribute('data-caption') || '';
        cap.textContent = c; cap.hidden = !c;
        dlg._opener = b;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else window.open(b.getAttribute('data-src'), '_blank');
      });
    });
  }

  function initAll(root) {
    initFormats();
    initLightbox(root);
    tcSchedule();
    initStoryPage(root);
    initAppHands(root);
    initCarousels(root);
    initWave(root);
    initFaqTabs(root);
    initMarquee(root);
    initPopup(root);
    initFaq(root);
    initImageFades(root);
    initMenus(root);
    initTabs(root);
    initNewsletter(root);
    observeReveals(root);
    if (io) onScroll();
  }

  function boot() {
    startMotion();
    initAll(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor: re-wire a section after it's edited or added
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
